var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "personalizacao-item-tile",
      attrs: { title: _vm.rotulo, "aria-label": _vm.rotulo }
    },
    [_c("icon-svg", { attrs: { name: _vm.icone, size: 18, color: "muted" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }